// import config from '../config.json'
// export default {
//   base_url: config.api_url,
//   thumb_url: config.thumb_url,
//   file_url: config.file_url,
//   audio_url: config.audio_url,
//   video_url: config.video_url,
//   other_url: config.other_url,
//   th_thumb_url: config.th_thumb_url,
//   domain: config.domain,
//   cookie_prefix: config.cookie_prefix,
//   teacher_url: config.teacher_url
// }
import Cookies from 'js-cookie'
// 默认连接dev接口 dev库
!Cookies.get('qd_baseUrl') && (Cookies.set('qd_baseUrl', 'https://dev.keyclass.cn'))
!Cookies.get('qd_store') && (Cookies.set('qd_store', 'dev'))
let cookieBaseUrl = Cookies.get('qd_baseUrl')
let cookieStore = Cookies.get('qd_store')

let config = {}
console.log(process.env.NODE_ENV)
// 'http://10.204.42.156:9099'

let baseUrlConfig = {
  dev: cookieBaseUrl,
  uat: 'https://uat.keyclass.cn',
  pro: 'https://www.keyclass.cn'
}

let baseUrl = baseUrlConfig[process.env.NODE_ENV]

if (process.env.NODE_ENV === 'dev') {
  config = {
    // site_name: cookieStore,
    site_name: cookieStore,
    local_url: baseUrl + '/studentServer',
    login_url: baseUrl + '/studentServer',
    base_url: baseUrl + '/studentServer',
    agent_url: baseUrl + '/agentServer',
    teacher_url: baseUrl + '/teacherServer',
    thumb_url: baseUrl + '/adminServer/fileUpload/imgUpload',
    article_file_url: baseUrl + '/adminServer/fileUpload/forumFileUpload',
    employee_thumb_url: baseUrl + '/adminServer/fileUpload/employeeImgUpload',
    file_url: baseUrl + '/adminServer/fileUpload/fileUpload',
    audio_url: baseUrl + '/adminServer/fileUpload/audioUpload',
    video_url: baseUrl + '/adminServer/fileUpload/videoUpload',
    other_url: baseUrl + '/adminServer/fileUpload/otherUpload',
    p2p_url: 'https://test.usongshu.com',
    cookie_prefix: 'qd_'
  }
} else if (process.env.NODE_ENV === 'uat') {
  config = {
    local_url: window.location.origin + '/studentServer',
    login_url: baseUrl + '/studentServer',
    base_url: baseUrl + '/studentServer',
    agent_url: baseUrl + '/agentServer',
    teacher_url: baseUrl + '/teacherServer',
    thumb_url: baseUrl + '/adminServer/fileUpload/imgUpload',
    article_file_url: baseUrl + '/adminServer/fileUpload/forumFileUpload',
    employee_thumb_url: baseUrl + '/adminServer/fileUpload/employeeImgUpload',
    file_url: baseUrl + '/adminServer/fileUpload/fileUpload',
    audio_url: baseUrl + '/adminServer/fileUpload/audioUpload',
    video_url: baseUrl + '/adminServer/fileUpload/videoUpload',
    other_url: baseUrl + '/adminServer/fileUpload/otherUpload',
    p2p_url: 'https://test.usongshu.com',
    cookie_prefix: 'qd_'
  }
} else if (process.env.NODE_ENV === 'pro') {
  config = {
    local_url: window.location.origin + '/studentServer',
    login_url: baseUrl + '/studentServer',
    base_url: baseUrl + '/studentServer',
    agent_url: baseUrl + '/agentServer',
    teacher_url: baseUrl + '/teacherServer',
    thumb_url: baseUrl + '/adminServer/fileUpload/imgUpload',
    article_file_url: baseUrl + '/adminServer/fileUpload/forumFileUpload',
    employee_thumb_url: baseUrl + '/adminServer/fileUpload/employeeImgUpload',
    file_url: baseUrl + '/adminServer/fileUpload/fileUpload',
    audio_url: baseUrl + '/adminServer/fileUpload/audioUpload',
    video_url: baseUrl + '/adminServer/fileUpload/videoUpload',
    other_url: baseUrl + '/adminServer/fileUpload/otherUpload',
    p2p_url: 'https://point.usongshu.com',
    cookie_prefix: 'qd_'
  }
}
export default config



// WEBPACK FOOTER //
// ./src/global/configure.js